import { FC } from "react";
import { Datagrid, List, TextField } from "react-admin";
import ClientName from "../../../components/ClientData/components/ClientName";

import CustomPagination from "../../../components/CustomPagination";
import EmptyDataText from "../../../components/EmptyDataText";
import TimestampField from "../../../components/TimestampField";
import ListRowActions from "./components/ListRowActions";
import RequestDate from "./components/RequestDate";
import RequestDateStatus from "./components/RequestDateStatus";
import RequestPaymentMethod from "./components/RequestPaymentMethod";
import RequestPrice from "./components/RequestPrice";

const RequestsList: FC<any> = (props) => {
  return (
    <List
      {...props}
      sort={{ field: "createdAt", order: "desc" }}
      pagination={<CustomPagination />}
      bulkActionButtons={false}
      filters={undefined}
      exporter={false}
    >
      <Datagrid empty={<EmptyDataText message="No requests yet!" />}>
        <ClientName label="Client" />
        <TextField source="service.name.en" label="Service Name" sortable={false} />

        <RequestPrice label="Price" />
        <RequestPaymentMethod label="PaymentMethod" />
        <RequestDate label="Date" source="date" sortable={false} />
        <RequestDateStatus label="Changed Time Status" />
        <TextField source="status" label="Status" sortable={false} />
        <TimestampField source="createdAt" label="Created At" />

        <ListRowActions />
      </Datagrid>
    </List>
  );
};

export default RequestsList;
